export default __webpack_public_path__ + "static/media/logo-segfy.c631c261.svg";